/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { NgModule } from '@angular/core';

import { NbIconModule } from '@nebular/theme';

import { NbTooltipComponent } from './tooltip.component';
import { NbTooltipDirective } from './tooltip.directive';

import { CommonModule } from '@angular/common';
import { SanitizeHtmlPipe } from '@theme/pipes/sanitizeHtml.pipe';

@NgModule({
  imports: [NbIconModule, CommonModule],
  declarations: [NbTooltipComponent, NbTooltipDirective, SanitizeHtmlPipe],
  exports: [NbTooltipDirective, SanitizeHtmlPipe],
})
export class NbTooltipModule {}
